import * as Sentry from '@sentry/react';
import parseJsonResponse from 'App/Helpers/parseJsonResponse';
import { getGamblingModalSlug } from 'App/Services/LegalPages';

import parseWpPage from '../helpers/parseWpPage';

/**
 * Fetches one gambling legal page by type and stores it on `cache`.
 * Used by the React hook and the legacy class so fetch/Sentry stay in one place.
 *
 * @param {string} url
 * @param {object} modals_slug
 * @param {'about'|'privacy'|'terms'} type
 * @param {Record<string, { title: string, content: string }>} cache
 * @returns {Promise<{ title: string, content: string }>}
 */
export async function fetchGamblingLegalText(url, modals_slug, type, cache) {
    if (cache[type]) {
        return cache[type];
    }

    const slug = getGamblingModalSlug(modals_slug, type);
    const reqUrl = url + slug;

    try {
        const res = await fetch(reqUrl);
        const data = await parseJsonResponse(res, `websiteData:${type}`);
        const text = parseWpPage(data);

        if (!text) {
            throw new Error(`Empty legal page for ${type}`);
        }

        cache[type] = text;

        return text;
    } catch (e) {
        if (e?.name === 'NonJsonResponseError') {
            Sentry.captureException(e, {
                tags: { non_json_response: e.requestLabel },
            });
            e.sentryCaptured = true;
        }

        throw e;
    }
}
